import { PATH_TO_VIEW } from '../../routes';
import { DEFAULT_STATE, loadUiPrefs } from '../../uiPrefs';
import { resolveUpdate } from './resolve';

export const createApplicationSlice = (set) => ({
  appState: (() => {
    const p = loadUiPrefs();
    const pathView = PATH_TO_VIEW[window.location.pathname];
    return { ...DEFAULT_STATE, ...(p || {}), ...(pathView ? { view: pathView } : {}) };
  })(),
  setAppState: (suivant) => set((etat) => ({ appState: resolveUpdate(suivant, etat.appState) })),
  modal: null,
  setModal: (suivant) => set((etat) => ({ modal: resolveUpdate(suivant, etat.modal) })),
  modalData: {},
  setModalData: (suivant) => set((etat) => ({ modalData: resolveUpdate(suivant, etat.modalData) })),
  form: {},
  setForm: (suivant) => set((etat) => ({ form: resolveUpdate(suivant, etat.form) })),
  viewAsMemberId: null, // "Voir en tant que" (manager) — aperçu lecture seule de l'interface dev
  setViewAsMemberId: (suivant) =>
    set((etat) => ({ viewAsMemberId: resolveUpdate(suivant, etat.viewAsMemberId) })),
  appDataLoaded: false,
  setAppDataLoaded: (suivant) =>
    set((etat) => ({ appDataLoaded: resolveUpdate(suivant, etat.appDataLoaded) })),
  migrating: false,
  setMigrating: (suivant) => set((etat) => ({ migrating: resolveUpdate(suivant, etat.migrating) })),
  sidebarCollapsed: false,
  setSidebarCollapsed: (suivant) =>
    set((etat) => ({ sidebarCollapsed: resolveUpdate(suivant, etat.sidebarCollapsed) })),
  navScale: 1,
  setNavScale: (suivant) => set((etat) => ({ navScale: resolveUpdate(suivant, etat.navScale) })),
  navBoxHeight: null,
  setNavBoxHeight: (suivant) =>
    set((etat) => ({ navBoxHeight: resolveUpdate(suivant, etat.navBoxHeight) })),
});
